import {
  DELETE_TASKS_KEY,
  EDIT_TASK_KEY,
  TASK_HISTORY_KEY,
  TASK_PREVIEW_KEY,
} from '@app/pages/TasksList/constants/dropdownKeys';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';
import { getMassActionMenuItem } from '@app/utils/getMassActionMenuItem';

import type { MenuProps } from 'antd';

export const ModalDropdownItems = ({
  isEditModal,
  isHistoryModal,
  isPreviewModal,
  handleDeleteModalOpen,
  openHistoryModal,
  currentTaskId,
  handleEditModalOpen,
  handlePreviewModalOpen,
  rightToCreateDeleteTask,
  rightToEditTask,
}: NTasksList.ModalDropdownItemsProps) => {
  const items: MenuProps['items'] = [
    ...(isEditModal || isHistoryModal
      ? [
          getMassActionMenuItem({
            key: TASK_PREVIEW_KEY,
            label: 'Просмотр задачи',
            onClick: handlePreviewModalOpen,
            disabled: false,
          }),
        ]
      : []),
    ...((isHistoryModal || isPreviewModal) && rightToEditTask
      ? [
          getMassActionMenuItem({
            key: EDIT_TASK_KEY,
            label: 'Редактировать задачу',
            onClick: () => handleEditModalOpen(currentTaskId),
            disabled: false,
          }),
        ]
      : []),
    ...(isEditModal || isPreviewModal
      ? [
          getMassActionMenuItem({
            key: TASK_HISTORY_KEY,
            label: 'История изменений',
            onClick: openHistoryModal,
            disabled: false,
          }),
        ]
      : []),
    ...(rightToCreateDeleteTask
      ? [
          getMassActionMenuItem({
            key: DELETE_TASKS_KEY,
            label: 'Удалить задачу',
            onClick: handleDeleteModalOpen,
            disabled: false,
          }),
        ]
      : []),
  ];

  return items;
};
